import { render } from "./TipoDocumentosIndex.vue?vue&type=template&id=04a5f38a"
import script from "./TipoDocumentosIndex.vue?vue&type=script&lang=js"
export * from "./TipoDocumentosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/TipoDocumentosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04a5f38a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04a5f38a', __exports__)) {
    api.reload('04a5f38a', __exports__)
  }
  
  module.hot.accept("./TipoDocumentosIndex.vue?vue&type=template&id=04a5f38a", () => {
    api.rerender('04a5f38a', render)
  })

}


export default __exports__